import { styled } from 'solid-styled-components';
import theme from '../../../../style/theme';

type OutputProps = { 
    bgColor?: string; 
    withLoadingSpinner?: boolean;
};

export const StyledOutput = styled.div<OutputProps>`
    background-color: ${ p => p.bgColor ? p.bgColor : theme.palette.white};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing.s};
    ${p => p.withLoadingSpinner ? `padding-inline: ${theme.spacing.s};` : ''}
    margin-top: ${theme.spacing.s};
    display: flex;
    align-items: center;

    @media print {
        display: none;
    }
`;

export const StyledLoadingSpinnerContainer = styled.div`
    min-width: 3rem;
    min-height: 3rem;
    margin-right: 1.5rem;
`;

export const StyledCollection = styled.div<{ active?: boolean; }>`    
    border-radius: ${theme.borderRadius.medium};
    margin-bottom: 3rem;
    background-color: #fff;
    ${p => p.active ? 'box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;' : ''}
`;

export const StyledEmptyCollection = styled.div`
    padding-inline: 3rem;
    padding-block: 2.5rem;
    border-radius: ${theme.borderRadius.medium};
    margin-bottom: 3rem;
    background-color: #fff;
`;

export const StyledListItemForPdf = styled.div`
    display: flex;
    align-items: flex-start;
    &::before {
        content: '•';
        margin-top: 0.15em;
        color: ${theme.palette.darkGray};
        font-size: 1.2rem;
        padding-right: 0.7rem;
    }
`;

export const StyledExpandableContainerContents = styled.div<{ bgColor?: string }>`
    background-color: ${p => p.bgColor};
    padding-block: ${theme.spacing.m};
    padding-inline: ${theme.spacing.ms};
    padding-top: 0;
    border-bottom-left-radius: 1.43rem;
    border-bottom-right-radius: 1.43rem;

    ${theme.mediaQueries.mobileMax} {
        font-size: 1.29rem;

        border-bottom-left-radius: 1.1rem;
        border-bottom-right-radius: 1.1rem;
        padding: ${theme.spacing.xs};
    }
`;

